var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5.16A8.338 8.338 0 00.16 8.5c0 4.609 3.745 8.34 8.34 8.34s8.34-3.745 8.34-8.34S13.11.16 8.5.16zm0 1.009c1.806 0 3.453.65 4.728 1.74L11.21 4.914A4.501 4.501 0 008.5 3.998c-1.01 0-1.966.345-2.71.916L3.773 2.91A7.313 7.313 0 018.5 1.169zM11.98 8.5a3.483 3.483 0 01-3.48 3.48A3.483 3.483 0 015.02 8.5 3.492 3.492 0 018.5 5.02a3.492 3.492 0 013.48 3.48zm-10.811 0A7.23 7.23 0 013.04 3.626L5.047 5.63A4.465 4.465 0 004.01 8.5c0 1.023.345 1.966.916 2.71L2.91 13.227A7.313 7.313 0 011.169 8.5zM8.5 15.831a7.23 7.23 0 01-4.874-1.872l2.005-2.006A4.465 4.465 0 008.5 12.99c1.09 0 2.098-.385 2.869-1.036l2.005 2.006A7.294 7.294 0 018.5 15.83zm5.591-2.603l-2.005-2.019a4.5 4.5 0 00.916-2.709c0-1.089-.385-2.098-1.036-2.869l2.006-2.005c1.155 1.301 1.873 3.001 1.873 4.874a7.397 7.397 0 01-1.754 4.728z"
  })));
};

export default SvgSupport;